import { render } from "./ShoppingListRecommendationListItem.vue?vue&type=template&id=fb417436&scoped=true&ts=true"
import script from "./ShoppingListRecommendationListItem.vue?vue&type=script&lang=ts"
export * from "./ShoppingListRecommendationListItem.vue?vue&type=script&lang=ts"

import "./ShoppingListRecommendationListItem.vue?vue&type=style&index=0&id=fb417436&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb417436"]])

export default __exports__